/**
 * Customer-specific formatters.
 *
 * The shared bits (`initialsFor`, `avatarClassFor`) live in
 * `features/master-list/lib/avatar-palette.ts` so customers + vendors +
 * future masters share one palette. Anything that's strictly
 * customer-shape-specific stays here.
 */

// Re-export the shared helpers so existing import paths in this feature
// keep working without churn.
export { initialsFor, avatarClassFor } from "../../master-list/lib/avatar-palette.ts";

/**
 * GSTIN positions 3–12 (1-indexed) carry the PAN of the registered entity.
 * Used on the detail page to display PAN without storing it as a separate
 * column. Returns null if the GSTIN is malformed.
 */
export function panFromGstin(gstin: string | null | undefined): string | null {
  if (!gstin || gstin.length !== 15) return null;
  // GSTIN: SS PPPPPPPPPP E Z C
  // pos 0-1: state code · pos 2-11: PAN (10 chars) · pos 12: entity · pos 13: 'Z' · pos 14: checksum
  return gstin.slice(2, 12);
}

/**
 * "Customer since Mar 2026" — used on the detail page chip. Mirrors the
 * prototype's `head-pill ago` styling text. Vendors uses the same shape
 * (`vendor-since`) so this could lift to `master-list` later if a third
 * vertical needs it.
 */
export function customerSince(createdAtIso: string): string {
  const d = new Date(createdAtIso);
  return d.toLocaleDateString("en-IN", { month: "short", year: "numeric" });
}
